import { useEffect } from 'react';
import { useTranslation } from '@frontend/i18n';
import { useAppScopeNaming } from '@frontend/scope';
import { theme } from '@frontend/theme';
import { Chip, DropdownFilterChipField, Text, useFormField } from '@frontend/design-system';
import { useContentComposer } from '../content-composer-provider';

export const LocationPicker = () => {
  const { t } = useTranslation('content-composer');
  const { locationIds, selectedLocationId, setSelectedLocationId } = useContentComposer();
  const { getScopeName } = useAppScopeNaming();
  const locationPickerFieldProps = useFormField({
    type: 'checklist',
    value: [selectedLocationId],
  });

  useEffect(() => {
    setSelectedLocationId(locationPickerFieldProps.value[0] ?? '');
  }, [locationPickerFieldProps.value, setSelectedLocationId]);

  return locationIds.length > 1 ? (
    <DropdownFilterChipField
      {...locationPickerFieldProps}
      className='composer-location-picker'
      css={{
        backgroundColor: theme.colors.white,
        border: 0,
        boxShadow: theme.shadows.light,
        left: theme.spacing(1),
        maxWidth: 400,
        paddingRight: theme.spacing(2),
        position: 'absolute',
        top: theme.spacing(1),
        transition: 'all 150ms ease',
        zIndex: theme.zIndex.overlay,

        '&:hover, &:focus': {
          boxShadow: theme.shadows.floating,
          outline: 'none',
        },
      }}
      isSingleSelect
      label={
        <Text
          as='div'
          size='medium'
          color='subdued'
          style={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1), paddingRight: theme.spacing(1) }}
        >
          <Chip.MultiChip css={{ marginRight: theme.spacing(1) }}>
            {t(`{{count}} Locations`, { count: locationIds.length })}
          </Chip.MultiChip>
          <span>{t('Viewing:')}</span>
          <span css={{ color: theme.colors.primary50 }}>
            {selectedLocationId ? getScopeName(selectedLocationId, 'location') : t('No Location Selected')}
          </span>
        </Text>
      }
      name='location-picker'
      showSelectionBar={false}
    >
      {locationIds.map((locationId) => (
        <DropdownFilterChipField.SingleSelectOption key={locationId} value={locationId}>
          {getScopeName(locationId, 'location')}
        </DropdownFilterChipField.SingleSelectOption>
      ))}
    </DropdownFilterChipField>
  ) : null;
};
